import { useContext } from "react"
import RightArrow from '../../docs/light/right.png';
import LeftArrow from '../../docs/light/left.png';
import '../../style/components/scroll.css';
import { config } from "../../context/config";

export default function Pagination (props) {
    const {page,setPage} = useContext(config);
    return (
        <div className="scroll flex flex-center-center">
            <button onClick={() => page <= 1 ? setPage(1) : setPage((prev) => prev - 1)}><img alt="less" src={LeftArrow} width={20} /></button>
            <span>{page} / {props.max}</span>
            <button onClick={() => page >= props.max ? setPage(props.max) : setPage((prev) => prev + 1)}><img alt="more" src={RightArrow} width={20}/></button>
        </div>  
    )
}